































































import { Component, Mixins } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { getStartGuideType } from '@/utils/start-guide';
import { IBusinessType } from '@/models/business';

import WelcomeCoinsIcon from '@/components/icons/WelcomeCoins.vue';
import EmailAutomationIcon from '@/components/icons/EmailAutomation.vue';
import InviteCustomersIcon from '@/components/icons/InviteCustomers.vue';
import SocialRewardsIcon from '@/components/icons/SocialRewards.vue';
import ReferralProgramIcon from '@/components/icons/ReferralProgram.vue';
import RewardsWidgetIcon from '@/components/icons/RewardsWidget.vue';

import CircleLock from '@/componentsV2/atoms/CircleLock/CircleLock.vue';

import RewardsModel from '@/componentsV2/templates/RewardsModel/RewardsModel.vue';

import { getFeaturesMapper } from './features';
import CoinNetworkFeatureTag from '@/componentsV2/atoms/CoinNetworkFeatureTag/CoinNetworkFeatureTag.vue';
import eventBus from '@/utils/eventBus';
import BillingService from '@/api/BillingService';
import BillingModel from '@/views/Models/BillingModel.vue';
import { getBillingIsPending } from '@/utils/billing';

@Component({
  components: {
    FilledButton,
    WelcomeCoinsIcon,
    EmailAutomationIcon,
    InviteCustomersIcon,
    SocialRewardsIcon,
    ReferralProgramIcon,
    RewardsWidgetIcon,
    CircleLock,
    CoinNetworkFeatureTag
  }
})
export default class LaunchRewardsProgramEmptyState extends Mixins(
  RewardsModel,
  BillingModel
) {
  featuresMapper = getFeaturesMapper(getStartGuideType());

  billingService = new BillingService();

  get feature() {
    return this.featuresMapper[this.$route.name as string];
  }

  get isBoth() {
    return getStartGuideType() === IBusinessType.BOTH;
  }

  get isInStore() {
    return getStartGuideType() === IBusinessType.INSTORE;
  }

  get isOnlineOnly() {
    return getStartGuideType() === IBusinessType.ONLINE;
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get showOnlineLoyaltyText() {
    let urlsNeedChooseOperate = [
      '/coin/loyalty',
      '/coin/policies',
      '/program-status'
    ];
    const isIncludedUrl = urlsNeedChooseOperate.some(item =>
      window.location.href.includes(item)
    );

    return this.isBoth && !isIncludedUrl;
  }

  get buttonLabel() {
    if (this.inactiveBilling) return 'Upgrade & Set up Loyalty Rewards Program';

    return `Set up ${
      this.showOnlineLoyaltyText ? 'Online' : ''
    } Loyalty Rewards Program`;
  }

  get titleFormatted() {
    if (this.feature.name)
      return `Set up your ${
        this.showOnlineLoyaltyText ? 'Online' : ''
      } Loyalty Rewards Program to unlock ${this.feature.text ||
        this.feature.name}`;

    return `Set up your Loyalty Rewards Program`;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  geticonBySlug(slug: string) {
    const slugFormatted = slug
      .toLocaleLowerCase()
      .split('-')
      .join('');

    const actionMapper: Record<string, () => string> = {
      welcomecoins: () => 'WelcomeCoinsIcon',
      emailautomation: () => 'EmailAutomationIcon',
      invitecustomers: () => 'InviteCustomersIcon',
      socialrewards: () => 'SocialRewardsIcon',
      referralprogram: () => 'ReferralProgramIcon',
      rewardswidget: () => 'RewardsWidgetIcon'
    };
    if (!actionMapper[slugFormatted]) return '';

    return actionMapper[slugFormatted]();
  }

  onActivateBilling() {
    const modal = getBillingIsPending() ? 'Acceptance' : 'Reactivation';
    this.onClickUpgrade({
      onSuccess: () => {
        if (modal === 'Reactivation') this.onOpenRewardsModal();
      },
      props: {
        welcomeCtaText: 'Set up Loyalty Rewards Program',
        origin: 'Empty State Loyalty Rewards'
      }
    });
  }

  onOpenRewardsModal() {
    if (this.showOnlineLoyaltyText) {
      this.$store.dispatch('rewardsProgram/SET_FORM_DATA', {
        operationType: IBusinessType.ONLINE
      });
    }

    this.openRewardsProgramModal({
      operationType: this.businessInfo.operationType,
      feature: this.$route.path
    });
  }

  async onLaunch() {
    if (this.inactiveBilling) {
      this.onActivateBilling();

      return;
    }

    this.onOpenRewardsModal();
  }

  created() {
    eventBus.$on('upgradeBillingEmptyState', this.onActivateBilling);
  }

  beforeDestroy() {
    eventBus.$off('upgradeBillingEmptyState', this.onActivateBilling);
  }
}
